import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { accessToken } from '../../../../configuration/tokenHandling/accessToken';
import { fetchContractsThunk } from '../../common/termedLevel/termedLevel.thunk';
import { getMarketplaceBackend } from '../../config/pathURL/config';
import { transformRtkQueryError } from '../api';

export interface CancelContractsRequest {
    productId: string;
    resourceIds: string[];
}

export const contractApiSlice = createApi({
    reducerPath: 'contractApi',
    baseQuery: fetchBaseQuery({
        baseUrl: getMarketplaceBackend(),
        prepareHeaders: headers => {
            const token = accessToken.getAccessToken();
            if (token) {
                headers.set('Authorization', `Bearer ${token}`);
            }
            return headers;
        },
    }),
    endpoints: builder => ({
        cancelContracts: builder.mutation<void, CancelContractsRequest>({
            query: ({ productId, resourceIds }) => ({
                url: `/contracts/${productId}/cancel`,
                method: 'POST',
                body: { resource_ids: resourceIds },
                responseHandler: (response: Response) => response.text(),
            }),
            onQueryStarted: async (_arg, { dispatch, queryFulfilled }) => {
                try {
                    await queryFulfilled;
                    await dispatch(fetchContractsThunk(false));
                } catch {}
            },
            transformResponse: () => undefined,
            transformErrorResponse: response => transformRtkQueryError(response, [401, 403]),
        }),
    }),
});

export const { useCancelContractsMutation } = contractApiSlice;
